interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  const baseBtn =
    "flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm transition-colors";

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className={`${baseBtn} border-background-300 text-foreground-600 hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? "page" : undefined}
          className={
            item === page
              ? `${baseBtn} border-primary-600 bg-primary-600 font-semibold text-background-50`
              : `${baseBtn} border-background-300 text-foreground-700 hover:bg-background-100`
          }
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className={`${baseBtn} border-background-300 text-foreground-600 hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}